import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ChatFlowCaption from 'components/@home/@settings/Tabs/ChatFlowCaption';
import ExpandMoreIcon from 'mdi-react/ExpandMoreIcon';
import { object, string } from 'prop-types';
import React, { useMemo } from 'react';
import { I18n } from 'utils/i18n';

const getStyles = theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.secondary.light}`,
    '&.Mui-expanded': {
      margin: 0,
    },
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightBold,
  },
  summaryRoot: {
    '&:hover': {
      backgroundColor: theme.palette.secondary.ultraLight,
    },
    '&.Mui-expanded': {
      minHeight: 0,
      '&:hover': {
        backgroundColor: 'initial',
      },
    },
  },
  details: {
    flexDirection: 'column',
    paddingTop: 0,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
});

const ChatFlowSection = ({ section, caption = false, children = null }) => {
  const theme = useTheme();
  const styles = useMemo(() => getStyles(theme), [theme]);

  return (
    <Accordion square defaultExpanded elevation={0} sx={styles.root}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`${section}-content`}
        id={`${section}-header`}
        sx={styles.summaryRoot}
      >
        <Typography
          sx={[
            {
              display: 'block',
            },
            styles.heading,
          ]}
        >
          {I18n.t(`ChatFlowSettings.${section}`)}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={styles.details}>
        {caption && <ChatFlowCaption section={section} />}
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

ChatFlowSection.propTypes = {
  caption: string,
  section: string.isRequired,
  children: object,
};

export default ChatFlowSection;
